import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="section-header">
            <h2 className="section-title">About Victor Charles</h2>
          </div>
          <div className="about-text">
            <p className="about-description">
              We are an entirely black owned, boutique business consulting firm that offers bespoke business development solutions.
            </p>
            <p className="about-description">
              We utilize a pragmatic approach to create innovative solutions that drives enterprise development. Your growth is our goal.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
